module.exports = "<section>\r\n     <div class=\"gw-endorsements-subsection\">\r\n        <gw-date-tile model=\"model\" max-date=\"maxDate\" on-next=\"onNext()\" min-date=\"minDate\"  mode=\"mode\" wizard-state=\"{{wizardState}}\" editable-states=\"editableStates\" immovable=\"true\"></gw-date-tile>\r\n    </div>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/directives/EffectiveDateDirective/effective-date.html
// module id = 731
// module chunks = 0